import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import '@babel/polyfill'
import axios from 'axios'
import router from './router'
import store from './store'
import configAxios from './axiosConfig/axiosConfig.js'

Vue.config.productionTip = false


Vue.use({
  install(Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: 'https://api.scan.law/'
    })
  }
})


// axios.interceptors.response.use
// configAxios.createAxiosResponseInterceptor()
configAxios.createAxiosUseInterceptor()
configAxios.createAxiosResponseInterceptor()

new Vue({
  vuetify,
  router,
  store,
  beforeCreate() { this.$store.commit('INITIALISATION_STORE') },
  render: h => h(App)
}).$mount('#app')
